// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3VWA-","inner":"Footer_inner__1WczP","nextIcon":"Footer_nextIcon__1jn6q","innerLeft":"Footer_innerLeft__348ko"};